const debug = true;
const color = 'rgb(255,75,75)';
const markColor = "rgba(255,75,75,0.45)";
const markSubColor = "rgba(255,75,75,0.2)";
const markGridX = 20;
const markGridY = 20;
const mountainWidth = markGridX;
const mountainOffset = markGridX;
const mountainHeight = markGridY * 2;
const stepSize = 1;
const pointAspectRatio = 1.145;
const mVRatio = markGridY / 0.5; // (1 mark = 0.5mV)
const xRatio = ( markGridX * 5 ) / 160; // point in sec / hz (1 mark = 200ms)

class ECGSingleChart {

    mountainArray = [{ x: 0, y: 0}, { x: mountainOffset, y: 0}, { x: mountainOffset, y: mountainHeight}, { x: mountainOffset + mountainWidth, y: mountainHeight}, { x: mountainOffset + mountainWidth, y: 0}, { x: (2*mountainOffset)+mountainWidth, y: 0}];
    minY = -1.6 * markGridY;
    maxY = 5.6 * markGridY;
    delayBetweenPoints = 0;
    
    lastData;
    lastResizeTimeout;
    startPrintTime;

    constructor(el, data = []) {
        this.el = document.getElementById(el);
        this.container = document.createElement("div");
        this.container.className = "chart-container";
        this.canvas = document.createElement("canvas");
        this.canvas.id = el+'_canvas';
        this.canvas.height = (this.maxY - this.minY) * (pointAspectRatio - 0.04);
        this.canvas.style.backgroundColor = 'rgba(255,255,255,1)';

        this.el.appendChild(this.container);
        this.container.appendChild(this.canvas);

        // this.initialMax = parseInt($(this.container).width()/pointAspectRatio);
        this.initialMax = $(this.container).width()/pointAspectRatio;

        if(data && this.initialMax < data.length * xRatio + (mountainOffset * 2 + mountainWidth)) {
            this.initialMax = data.length * xRatio + (mountainOffset * 2 + mountainWidth);

            let width = this.initialMax * pointAspectRatio;

            this.canvas.width = width;
            $(this.canvas).css('width', width);
            $(this.container).css('width', width);

            this.scrollContainer(data.length * 0.5);
        } else {
            let width = this.initialMax * pointAspectRatio;

            this.canvas.width = width;
            $(this.canvas).css('width', width);
        }

        const convertedData = this.convertData(data);

        const last = convertedData[convertedData.length - 1];

        // if (this.initialMax < last.x) {
        //     this.initialMax = last.x;
        // }

        this.chart = new Chart(this.canvas.id, {
            type: 'line',
            data: {
                // labels: [''],
                datasets: [{
                    borderColor: color,
                    borderWidth: 1,
                    radius: 0,
                    data: convertedData,
                    fill: false,
                    tension: 0,
                    pointHoverBorderWidth: 0,
                    animation: false
                }]
            },
            options: {
                layout: {
                    padding: {
                        left: -10,
                        bottom: -10
                    }
                },
                animation: false,
                interaction: {
                    intersect: false
                },
                plugins: {
                    legend: false,
                    tooltip: {
                        displayColors: false,
                        callbacks: {
                            title: function(tooltipItem) {
                                return '';
                            },
                            label: (context) => {
                                var label = context.dataset.label || '';

                                if (context.parsed.y !== null) {
                                    label = context.parsed.y / mVRatio;
                                }

                                return label;
                            }
                        }
                    },
                },
                scales: {
                    x: {
                        type: 'linear',
                        min: 0,
                        // max: data.length < 100 ? 100 : data.length,
                        max: this.initialMax,
                        grid: {
                            color: function(line) {
                                if(line.tick.value % markGridX == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markColor;
                                }
                                else if(line.tick.value % (markGridX / 5) == 0) {
                                    return markSubColor;
                                }

                                return false;
                            }
                        },
                        ticks: {
                            display: false,
                            stepSize: stepSize,
                        },
                    },
                    y: {
                        min: this.minY,
                        max: this.maxY,
                        type: 'linear',
                        grid: {
                            color: function(line) {
                                if(line.tick.value % markGridY == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markColor;
                                } else if(line.tick.value % (markGridY / 5) == 0) {
                                    // console.info('mark line', line);
                                    // return "rgba(0,0,0)";
                                    return markSubColor;
                                }

                                return false;
                            }
                        },
                        ticks: {
                            display: false,
                            stepSize: stepSize
                        },
                    },
                },
                responsive: true,
                maintainAspectRatio: false
            }
        });

        $(window).on('resize', () => {
            this.resizeContainer();
            this.chart.update();
        });
    }

    // get animation() {
    //     return {
    //         x: {
    //             type: 'number',
    //             easing: 'linear',
    //             duration: 1,
    //             from: NaN, // the point is initially skipped
    //             // from: (ctx) => {
    //             //     return ctx.index === 0 ? ctx.chart.scales.x.getPixelForValue(100) : !!ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1] ? ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['x'], true).x : 0;
    //             // },
    //             delay: function(ctx) {
    //                 if (ctx.type !== 'data' || ctx.xStarted) {
    //                     return 0;
    //                 }
    //                 ctx.xStarted = true;
    //                 return ctx.index * this.delayBetweenPoints;
    //             }
    //         },
    //         y: {
    //             type: 'number',
    //             easing: 'linear',
    //             duration: 1,
    //             from: (ctx) => {
    //                 return ctx.index === 0 ? ctx.chart.scales.y.getPixelForValue(100) : !!ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1] ? ctx.chart.getDatasetMeta(ctx.datasetIndex).data[ctx.index - 1].getProps(['y'], true).y : 0;
    //             },
    //             delay: function(ctx) {
    //                 if (ctx.type !== 'data' || ctx.yStarted) {
    //                     return 0;
    //                 }
    //                 ctx.yStarted = true;
    //                 return ctx.index * this.delayBetweenPoints;
    //             }
    //         },
    //         // onResize: () => {
    //         //     console.log('resizing');
    //         //     this.resizeContainer();
    //         // }
    //         // onComplete: () => {
    //         //     console.debug('ANIMATION COMPLETE');
    //         //     this.scrollContainer();
    //         // }
    //     }
    //     // const animation = {
    //     //     xAxes: {
    //     //         type: 'number',
    //     //         easing: 'linear',
    //     //         duration: delayBetweenPoints,
    //     //         from: NaN, // the point is initially skipped
    //     //         delay(ctx) {
    //     //             if (ctx.type !== 'data' || ctx.xStarted) {
    //     //                 return 0;
    //     //             }
    //     //             ctx.xStarted = true;
    //     //             return ctx.index * this.delayBetweenPoints;
    //     //         }
    //     //     },
    //     //     yAxes: {
    //     //         type: 'number',
    //     //         easing: 'linear',
    //     //         duration: delayBetweenPoints,
    //     //         from: previousY,
    //     //         delay(ctx) {
    //     //             if (ctx.type !== 'data' || ctx.yStarted) {
    //     //                 return 0;
    //     //             }
    //     //             ctx.yStarted = true;
    //     //             return ctx.index * this.delayBetweenPoints;
    //     //         }
    //     //     }
    //     // };
    // }

    checkNewData(newData) {
        const currentData = this.chart.data.datasets[0].data;

        if(currentData.length != newData.length) {
            // console.debug('CHECK LENGTH!!!');
            return true;
        }

        for(var i=0; i<currentData.length; i++) {
            if(currentData[i].x != newData[i].x || currentData[i].y != newData[i].y) {
                // console.debug('DIFFERENT DATA!!!', currentData[i], newData[i]);
                return true;
            }
        }

        return false;
    }

    convertData(data, mountain = true) {
        let x = 0;
        var newData = [];

        if(mountain) {
            $(this.mountainArray).each(function(i, item) {
                newData.push({
                    x: item.x,
                    y: item.y
                });

                x = item.x;
            });
        }

        $(data).each(function(i, item) {
            if(i > 10000) {
                return;
            }

            let y = item * mVRatio;

            if (y > this.maxY) {
                y = this.maxY;
            }

            if(y < this.minY) {
                y = this.minY;
            }

            // console.debug(i, item, x, y);
            newData.push({
                x: x,
                y: y
            });

            x += xRatio;
        });

        // if(debug && newData.length > 2) {
        //     console.debug(newData.length, newData[newData.length - 2]);
        //     newData[newData.length - 2].y = this.minY;
        //     newData[newData.length - 1].y = this.maxY;
        // }

        return newData;
    }

    setData(data) {
        if(debug) {
            console.debug('chart', this.chart, this.chart.scales);
        }

        data = this.convertData(data);

        if(!this.checkNewData(data)) {
            if(debug) {
                console.debug('ignoring data. same array');
            }

            return;
        }

        if(!this.startPrintTime || !this.lastData || this.lastData.length > data.length) {
            if(debug) {
                console.log('setting startPrintTime');
            }
            this.startPrintTime = Date.now();
        }

        const currentLength = !!this.lastData ? this.lastData.length : 0;
        const newPointCount = data.length - currentLength;
        const step = parseInt(newPointCount / 5) + 1;

        const hz = 160;
        const printingOffsetTimeout = 1000;
        // baseTimeout rappresenta il tempo necessario per renderizzare i precedenti dati ( 160hz, 160 punti in 1 sec ) meno il tempo trascorso dall'inizio del rendering
        const baseTimeout = (currentLength / hz * 1000) - (Date.now() - this.startPrintTime) + printingOffsetTimeout; // + 1000
        // printTimeout rappresenta il tempo necessario per renderizzare i nuovi punti ( 160hz, 160 punti in 1 sec )
        const printTimeout = 1000 / hz * newPointCount;

        if(debug) {
            console.log('start: %d, currentLength: %d, currentTime: %d, timeDiff: %d, baseTimeout: %d, newPointCount: %d, newPointTime: %d, timeout: %d', this.startPrintTime, currentLength, (currentLength / 160 * 1000), (Date.now() - this.startPrintTime), baseTimeout, newPointCount, printTimeout);
        }

        for(let i = 0; i < step; i++) {
            let timeout = baseTimeout + parseInt(i / ( step - 1 ) * printTimeout);
            setTimeout(() => {
                this.chart.data.datasets[0].data = data.slice(0, currentLength + ((i + 1) / step) * newPointCount);

                this.resizeContainer();
                this.scrollContainer(0);

                this.chart.update();
            }, timeout);
            // console.log('timeout', timeout);
        }

        clearTimeout(this.lastResizeTimeout);
        this.lastResizeTimeout = setTimeout(() => {
            if(debug) {
                console.log('last resizing');
            }
            this.resizeContainer();
            this.chart.update();
        }, baseTimeout + printTimeout + 600);

        // setTimeout(() => {
        //     this.scrollContainer();
    
        //     var dataset = this.chart.data.datasets[0];
        //     dataset.data = data;
    
        //     if(debug) {
        //         console.debug('converted data', data, dataset.data);
        //     }
    
        //     setTimeout(() => {
        //         this.chart.update();
        //     }, 150);
        // }, 150);

        this.lastData = data;
    }

    // addData(data) {
    //     if(debug) {
    //         console.debug('chart', this.chart, this.chart.scales);
    //     }
    //     var dataset = this.chart.data.datasets[0];

    //     if(dataset.data.length == 0) {
    //         return this.setData(data);
    //     }
            
    //     x = this.chart.data.datasets[0].data[this.chart.data.datasets[0].data.length - 1].x;

    //     $(data).each(function(i, item) {
    //         dataset.data.push({
    //             x: x,
    //             y: item
    //         });
    //         x += 1;
    //     });

    //     this.resizeContainer(dataset.data);
    //     this.scrollContainer();

    //     if(dataset.data.length >= this.chart.config.options.scales.x.max) {
    //         if(debug) {
    //             console.debug('updating max');
    //         }
    //         this.chart.config.options.scales.x.max = dataset.data.length + 20;
    //     }
        
    //     this.chart.update();
    // }

    resizeContainer(data = null) {
        if(!data) {
            data = this.chart.data.datasets[0].data;
        }

        const maxLimit = parseInt(data[data.length - 1].x);

        // console.log(max, maxLimit, parseInt($(this.container).width()/pointAspectRatio) + 1);

        if(maxLimit < parseInt($(this.container).parent().width()/pointAspectRatio)) {
            this.chart.config.options.scales.x.max = parseInt($(this.container).parent().width()/pointAspectRatio);
            if(debug) {
                console.debug('resetting by parent max', this.chart.config.options.scales.x.max);
            }
        } else if(maxLimit < parseInt($(this.container).width()/pointAspectRatio)) {
            this.chart.config.options.scales.x.max = parseInt($(this.container).width()/pointAspectRatio);
            if(debug) {
                console.debug('resetting by container max', this.chart.config.options.scales.x.max);
            }
        } else if(maxLimit >= this.chart.config.options.scales.x.max) {
            this.chart.config.options.scales.x.max = maxLimit;
            if(debug) {
                console.debug('updating max', this.chart.config.options.scales.x.max);
            }
        }
        
        let width = this.chart.config.options.scales.x.max * pointAspectRatio;

        // if(debug) {
        //     console.debug('resizing', data.length, width);
        // }

        this.canvas.width = width;
        $(this.canvas).css('width', width);
        $(this.container).css('width', width);
    }

    scrollContainer(scrollTimeout = 300) {
        if(debug) {
            console.debug('scrolling', $(this.container).width(), $(this.container).parent().width(), parseInt($(this.container).width() - $(this.container).parent().width()) + 1, scrollTimeout);
        }
        
        if(scrollTimeout = 0) {
            $(this.container).parent().stop().setScrollLeft(parseInt($(this.container).width() - $(this.container).parent().width()) + 1);
        } else {
            $(this.container).parent().stop().animate({
                scrollLeft: parseInt($(this.container).width() - $(this.container).parent().width()) + 1
            }, scrollTimeout);
        }
    }

    toBase64Image(type, quality) {
        return this.chart.toBase64Image(type, quality);
    }
}

window.ECGSingleChart = ECGSingleChart;